import { render } from "./last-module.vue?vue&type=template&id=5c4c1f80"
import script from "./last-module.vue?vue&type=script&lang=js"
export * from "./last-module.vue?vue&type=script&lang=js"

import "./last-module.vue?vue&type=style&index=0&id=5c4c1f80&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__